import React from 'react';

const COLORS = {
  1: { fill: 'var(--player-1)', ring: 'var(--clay-700)', soft: 'var(--player-1-soft)' },
  2: { fill: 'var(--player-2)', ring: 'var(--pine-700)', soft: 'var(--player-2-soft)' },
};

/** A single pawn disc. Size is relative to its container by default. */
export function Pawn({ player = 1, active = false, size = '72%', style = {} }) {
  const c = COLORS[player] || COLORS[1];
  return (
    <span
      style={{
        width: size, aspectRatio: '1 / 1', borderRadius: '50%',
        background: `radial-gradient(circle at 35% 30%, ${c.fill}, ${c.ring})`,
        boxShadow: active
          ? `0 0 0 4px var(--surface-card), 0 0 0 7px ${c.fill}, 0 4px 10px rgba(0,0,0,.25)`
          : 'inset 0 -3px 6px rgba(0,0,0,.25), 0 3px 6px rgba(0,0,0,.22)',
        display: 'inline-block',
        transition: 'box-shadow var(--dur-base) var(--ease-standard), transform var(--dur-base) var(--ease-spring)',
        ...style,
      }}
    />
  );
}
